export { FlashAnimation, RENDER_FLASHANIMATION_TESTID } from './FlashAnimation';
export type { FlashAnimationProps } from './FlashAnimation';
